import styled from "@emotion/styled";
import CloseIcon from "static-file/images/btn_layer_close_b.png";
import upArrowIcon from "static-file/images/outlined-path.png";
import downArrowIcon from "static-file/images/downoutlined-path.png";
import { RootProps } from "./Modal";

export const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div<RootProps>`
  min-width: ${({ containerWidth }) => containerWidth || "374px"};
  width: fit-content;
  height: ${({ containerHeight }) => containerHeight || "529px"};
  background-color: #fff;
  border: ${({ border }) => (border ? "2px solid #000" : "none")};
`;

export const AlertModalContainer = styled.div`
  min-width: 340px;
  width: fit-content;
  background-color: #fff;
  border-radius: 12px;
`;

export const AlertHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  font-size: 20px;
  font-weight: 600;
  color: #373A41;
`;

export const AlertContent = styled.div`
  padding: 16px 24px;
  font-size: 16px;
  color: #373A41;
  font-weight: 400;
  white-space: pre-line;
`;

export const AlertBottom = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 24px 24px 24px;
`;


export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 8px 12px 8px 16px;
  background: #d6d8d9;
`;

export const TopTitle = styled.p`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
`;

export const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  background: url(${CloseIcon}) center center no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  text-indent: -9999px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const ContentContainer = styled.div`
  display: flex;
  max-height: 223px;
  margin-top: 8px;
  border: 1px solid #b2b3b4;
`;

export const ScrollArea = styled.div`
  flex-grow: 1;
  max-height: 223px;
  overflow-y: hidden;
`;

export const ScrollButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 40px;
  background: #ebedee;
  border-left: 1px solid #b2b3b4;
`;

export const ScrollButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 112px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const UpButton = styled(ScrollButton)`
  border-bottom: 1px solid #b2b3b4;
`;

export const Icon = styled.div`
  width: 18px;
  height: 9px;
  background-position: center;
  background-repeat: no-repeat;
`;

export const IconUp = styled(Icon)`
  background-image: url(${upArrowIcon});
`;

export const IconDown = styled(Icon)`
  background-image: url(${downArrowIcon});
`;

export const ButtonWrap = styled.div`
  display: flex;
  gap: 12px;
  padding: 24px 16px 34px;
`;

// CommonHeader
export const CommonTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 57px;
`;

export const CommonTopTitle = styled.p`
  font-size: 21px;
  font-weight: 700;
  color: #000;
`;

export const CommonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0px 20px;

  &.p-0 {
    padding: 0 !important;
  }
`;

export const CommonContentText = styled.div`
  color: #333b42;
  font-size: 19px;
  font-weight: 700;
`;

export const CommonBottom = styled.div`
  display: flex;
  justify-content: center;
`;

export const Divider = styled.div`
  height: 1px;
  background: #d9d9d9;
  margin: 0 16px;
`;
